import React from 'react';
import PropTypes from 'prop-types';

import { View } from 'react-native';
import { Interaction, Point, OffsetView } from '@dbk/ui-charts';

import { PALETTE } from '../../../../constants';
import { Currency } from '../../../../components/common/number';
import SimpleDate from '../../../../components/common/date';

import styles from './interactions.styles';

const VERTICAL_OFFSET = 10;

function Interactions({ data, currency, selectedValue, onChange }) {
  return (
    <Interaction xAxis="x">
      <Interaction.XGroup>
        <Interaction.VerticalLine
          top={VERTICAL_OFFSET}
          wrapper={Interaction.HideLink}
        />
        <Interaction.DataPointView
          top={VERTICAL_OFFSET}
          view={item => (
            <View
              style={styles.flag}
            >
              <SimpleDate
                renderProps={{
                  style: styles.flagDate,
                  size: 'small',
                }}
                value={item.date}
              />
              <Currency
                renderProps={{
                  style: styles.flagPrice,
                  size: 'small',
                }}
                value={item.price.value}
                currency={currency}
              />
            </View>
          )}
        />

      </Interaction.XGroup>
    </Interaction>
  );
}

Interactions.propTypes = {
  data: PropTypes.array.isRequired,
  currency: PropTypes.string,
  selectedValue: Interaction.propTypes.selectedValue,
  onChange: PropTypes.func,
};

export default Interactions;
